"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeplrQRCodeModalV1 = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const modal_1 = require("./modal");
class KeplrQRCodeModalV1 {
    constructor(uiOptions) {
        this.uiOptions = uiOptions;
    }
    open(uri, cb) {
        const wrapper = document.createElement("div");
        wrapper.setAttribute("id", "keplr-qrcode-modal-v1");
        document.body.appendChild(wrapper);
        react_dom_1.default.render(react_1.default.createElement(modal_1.Modal, { uri: uri, close: () => {
                this.close();
                cb();
            }, uiOptions: this.uiOptions }), wrapper);
    }
    close() {
        const wrapper = document.getElementById("keplr-qrcode-modal-v1");
        if (wrapper) {
            document.body.removeChild(wrapper);
        }
    }
}
exports.KeplrQRCodeModalV1 = KeplrQRCodeModalV1;
//# sourceMappingURL=index.js.map